import { Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { IRootState } from "redux/types";
import { RegistryPagination } from "pages/main/components/registry-section/registry-pagination";
import { useURLParamsSpreadsheets } from "hooks";
import { useEffect, useState } from "react";
import { assignmentsLoadAssignments } from "redux/slices/assignments.slice";
import { useForUserType } from "hooks/useForUserType";
import { AssignmentsRegistryTable } from "../assignments-registry-table";

const limit = 10;
export const AssignmentsRegistrySectionContent = () => {
  const { userType } = useForUserType();
  const dispatch = useDispatch();
  const { assignments } = useSelector((state: IRootState) => state.assignments);
  const { page, applicationNo, assignmentType, companyName, assigneeId, applicationYear } =
    useURLParamsSpreadsheets();

  const [curPg, setCurPg] = useState(page.get());
  const [maxPg, setMaxPg] = useState(page.get());

  const fetchList = async (pg) => {
    const offset = (pg - 1) * limit;
    dispatch(
      assignmentsLoadAssignments({
        limit: limit,
        offset: offset,
        userType: userType,
        application_no: Number(applicationNo.get()),
        assignment_type: assignmentType.get(),
        company_name: companyName.get(),
        assignee_id: assigneeId.get(),
        application_year: applicationYear.get()
      })
    );
  };

  const setPageWithLoad = (pg) => {
    setCurPg(pg);
    page.set(pg);
    fetchList(pg);
  };

  useEffect(() => {
    setCurPg(page.get());
  }, [page.get()]);

  useEffect(() => {
    if (assignments.value)
      setMaxPg(Math.ceil((assignments.value?.total ?? 1) / limit));
  }, [assignments.value]);

  return (
    <Box>
      <AssignmentsRegistryTable />
      {maxPg === 1 || maxPg === 0 ? null : (
        <RegistryPagination
          cur={curPg}
          max={maxPg}
          onClickNext={() => {
            setPageWithLoad(curPg + 1);
          }}
          onClickPrev={() => {
            setPageWithLoad(curPg - 1);
          }}
        />
      )}
    </Box>
  );
};
